const filters = 
{ 
    SHOW_ACTIVE: 'SHOW_ACTIVE', 
    SHOW_ALL: 'SHOW_ALL', 
    SHOW_DONE: 'SHOW_DONE'
}

export default filters;



// WEBPACK FOOTER //
// ./src/modules/todoMain/constants.js